export default function normalizePositionByRangeLength(pPosition, sequenceLength, isInBetweenPositions) {
  let position = pPosition;
  if (position < 0) {
    position += sequenceLength;
  } else if (position + (isInBetweenPositions ? 0 : 1) > sequenceLength) {
    position -= sequenceLength;
  }
  return position < 0 ? 0 : position > sequenceLength - (isInBetweenPositions ? 0 : 1) ? sequenceLength - (isInBetweenPositions ? 0 : 1) : position;
}
